module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-path-box"
  }, [_c('router-link', {
    attrs: {
      "tag": "span",
      "to": "/biomanager/"
    }
  }, [_c('span', {
    staticClass: "link-path"
  }, [_vm._v("home")])]), _vm._v("\n   / \n  "), _c('span', {
    staticClass: "link-path"
  }, [_vm._v(_vm._s(_vm.currentPath))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb219eca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/LinkPath.vue
// module id = 267
// module chunks = 0